import { useMemo } from "react";
import { useSelector } from "react-redux";

import { Box, Grid, Typography } from "@mui/material";

import AutoCompleteField from "components/_refactor/fields/autocomplete";

import themeColorsDesingSystem from "assets/theme/ds-colors";

export default function PriceTableSection({
  brandId,
  priceTableOptions,
  loadingPriceTables,
  priceTables,
  onChange,
}) {
  const editMode = useSelector((state) => state.criarVitrine.editMode);
  const originalStatus = useSelector(
    (state) => state.criarVitrine.originalStatus,
  );
  const originalPriceTableCodes = useSelector(
    (state) => state.criarVitrine.originalPriceTableCodes,
  );
  const lockedCodes = useMemo(() => {
    if (!editMode || originalStatus !== "PUBLICADO") return new Set();
    return new Set(originalPriceTableCodes);
  }, [editMode, originalStatus, originalPriceTableCodes]);

  const lockedEntries = (priceTables ?? []).filter((t) =>
    lockedCodes.has(t?.CodTabelaPreco),
  );

  // AutoCompleteField (multiple) não expõe lock por chip individual — em vez disso,
  // se uma remoção tirar alguma tabela já vinculada (originalPriceTableCodes), ela é
  // reinserida antes de propagar o onChange (mesma regra de superset-only do backend).
  const handleChange = (options) => {
    const newList = options ?? [];
    const newCodes = new Set(newList.map((t) => t?.CodTabelaPreco));
    const missingLocked = lockedEntries.filter(
      (t) => !newCodes.has(t?.CodTabelaPreco),
    );
    onChange(
      missingLocked.length > 0 ? [...newList, ...missingLocked] : newList,
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={8}>
        <Box sx={{ width: "100%" }}>
          <AutoCompleteField
            options={priceTableOptions}
            label="Tabela de preço"
            optionLabelKey="displayLabel"
            optionIdKey="CodTabelaPreco"
            multiple={true}
            onChange={handleChange}
            value={priceTables ?? []}
            required={true}
            disabled={!brandId || loadingPriceTables}
            loading={loadingPriceTables}
          />
        </Box>
        {lockedEntries.length > 0 ? (
          <Typography
            variant="caption"
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              ml: 2,
              color: themeColorsDesingSystem.gray.dark,
            }}
          >
            Não é possível remover tabela já vinculada a vitrine publicada:{" "}
            {lockedEntries
              .map((t) => t?.displayLabel || t?.CodTabelaPreco)
              .join(", ")}
          </Typography>
        ) : null}
      </Grid>
    </Grid>
  );
}
